
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/subject/[subjectKey]",
      function () {
        return require("private-next-pages/subject/[subjectKey].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/subject/[subjectKey]"])
      });
    }
  